import { useEffect, useMemo, useState } from 'react';
import { onValue, ref } from 'firebase/database';
import { db } from '../config/firebase';

export const useBranches = () => {
  const [map, setMap] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const branchesRef = ref(db, 'settings/branches');
    const unsub = onValue(
      branchesRef,
      (snapshot) => {
        setMap(snapshot.val() || {});
        setLoading(false);
      },
      () => {
        setMap({});
        setLoading(false);
      },
    );
    return () => unsub();
  }, []);

  const derived = useMemo(() => {
    const list = Object.entries(map || {})
      .map(([id, value]) => ({ ...value, id: value?.id || id }))
      .sort((a, b) => {
        const orderDiff = (a.order ?? 0) - (b.order ?? 0);
        if (orderDiff !== 0) return orderDiff;
        return String(a.name || '').localeCompare(String(b.name || ''));
      });
    const byId = list.reduce((acc, branch) => {
      acc[branch.id] = branch;
      return acc;
    }, {});
    const bySlug = list.reduce((acc, branch) => {
      if (branch.slug) acc[branch.slug] = branch;
      return acc;
    }, {});
    const activeList = list.filter((branch) => branch.isActive !== false);
    return { list, byId, bySlug, activeList };
  }, [map]);

  return { ...derived, map, loading };
};

export default useBranches;
